import { connect } from 'react-redux'

import * as orgSelectors from 'modules/org/selectors'
import * as userSelectors from 'modules/user/selectors'

import ConvoPreview from './component'

const mapStateToProps = (state) => ({
  name: userSelectors.getName(state),
  email: userSelectors.getEmail(state),
  color: orgSelectors.getColor(state),
  user: state.user,
})

export default connect(mapStateToProps)(ConvoPreview)
